import React from 'react';
import { dateByType } from './helper';
var DateFormat = function (_a) {
    var date = _a.date, _b = _a.type, type = _b === void 0 ? 'relative' : _b, extraTitle = _a.extraTitle, tooltipProps = _a.tooltipProps;
    var dateObj = date instanceof Date ? date : new Date(date);
    var invalid = date === undefined || date === null || dateObj.toString() === 'Invalid Date';
    var dateType = invalid ? 'invalid' : type;
    return React.createElement(React.Fragment, null, dateByType(dateType, tooltipProps, extraTitle)(dateObj));
};
export default DateFormat;
//# sourceMappingURL=DateFormat.js.map